import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainNavigation from './MainNavigation';
import BrandName from './BrandName';
import Footer from './Footer';
import { useCart } from '../contexts/CartContext';

const SharedPageLayout = ({ children, currentPage }) => {
  const navigate = useNavigate();
  const { cart } = useCart();
  
  const navigateToPage = (page) => {
    if (page === 'home') {
      navigate('/');
    } else if (page === 'products') {
      navigate('/products');
    } else if (page === 'cart') {
      navigate('/cart');
    } else if (page === 'about') {
      navigate('/about');
    } else if (page === 'services') {
      navigate('/services');
    } else if (page === 'contact') {
      navigate('/contact');
    } else if (page === 'marketplace') {
      navigate('/marketplace');
    } else if (page === 'profile') {
      navigate('/profile');
    } else if (page === 'admin') {
      navigate('/admin');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <MainNavigation 
        onNavigate={navigateToPage} 
        currentPage={currentPage} 
        cartCount={cart?.length || 0} 
      />
      <div className="flex-grow">
        {children}
      </div>
      <Footer onNavigate={navigateToPage} />
    </div>
  );
};

export default SharedPageLayout;